import { LabelValuePairs, LabelValuePair } from "../types";
/* istanbul ignore file */

export const enum2options = (e: object): LabelValuePairs =>
  Object.values(e).map((value): LabelValuePair => ({ label: value || "Selecteer een optie", value }));
